import type { ErrorListOutput } from '../../types';
import type { PaymentPlanCd } from './QuoteSchema';

export interface GetQuoteMutationInput {
  id: string;
  communityId: string;
  deductible: string;
  medicalPayments: string;
  personalPropertyCoverage: string;
  personalLiabilityCoverage: string;
  lossOfUse: string;
  theft: string;
  windHail: string;
  waterBackup?: string;
  petDamage?: string;
  identityFraud?: string;
  fireDepartmentService?: boolean;
  sinkHole?: boolean;
  ordinanceOrLaw?: boolean;
  rentalIncome?: boolean;
  workersCompensation?: boolean;
  earthquake?: number;
  hurricane?: number;
}

export type PaymentPlan =  {
  paymentPlanCd: PaymentPlanCd;
  totalPremiumAmt: string;
  installmentPaymentAmount: string;
  installmentFeeAmount: string;
  downPaymentAmount: string;
  installmentAmount: string;
}

export interface GetQuoteSuccessResponse {
  getQuote: {
    id: string;
    companyProductCd: string;
    paymentPlans: PaymentPlan[];
  };
}

export interface GetQuoteErrorResponse {
  getQuote: ErrorListOutput & {
    id: never;
    companyProductCd: never;
    paymentPlans: never;
  };
}

export type GetQuoteResponse = GetQuoteSuccessResponse | GetQuoteErrorResponse;

const optionalKeys: (keyof GetQuoteMutationInput)[] = [
  'deductible',
  'medicalPayments',
  'waterBackup',
  'petDamage',
  'identityFraud',
  'theft',
  'windHail',
  'hurricane',
  'personalPropertyCoverage',
  'personalLiabilityCoverage',
  'lossOfUse',
];

export const GET_QUOTE = (getQuote: GetQuoteMutationInput) => {
  let mutation = `mutation {
      getQuote(
        applicationId: "${getQuote.id}",
        input:{
          communityId: "${getQuote.communityId}",
          fireDepartmentService: ${getQuote.fireDepartmentService},
          sinkHole: ${getQuote.sinkHole},
          ordinanceOrLaw: ${getQuote.ordinanceOrLaw}, 
          rentalIncome: ${getQuote.rentalIncome},
          workersCompensation: ${getQuote.workersCompensation},
      `;

  optionalKeys.forEach((key) => {
    mutation += `${key}: ${getQuote[key] || 0},`;
  });

  mutation += `earthquake: ${
    getQuote.earthquake ? (getQuote.earthquake / 5000).toFixed(2) : 0
  }`;
  mutation += `}
          ) {
              ... on ApplicationOutput {
                  id,
                  companyProductCd,
                  paymentPlans {
                      paymentPlanCd,
                      installmentAmount,
                      totalPremiumAmt,
                      installmentPaymentAmount,
                      installmentFeeAmount,
                      downPaymentAmount,
                  }
              }
              ... on ErrorListOutput {
                  errors: errors {
                      type
                      message
                  }
              }
          }
      }`;
  return mutation;
};
